import React from "react";
import { SectionTitle } from "components/items";
import makeTitle from "function/makeTitle.js";

import partner_01 from "image/partner/partner-01.jpg";
import partner_02 from "image/partner/partner-02.jpg";
import partner_03 from "image/partner/partner-03.png";
import partner_04 from "image/partner/partner-04.png";

import partner_05 from "image/partner/partner-05.jpg";
import partner_06 from "image/partner/partner-06.jpg";

import partner_07 from "image/partner/partner-07.png";

import partner_08 from "image/partner/partner-08.jpg";
import partner_10 from "image/partner/partner-10.jpg";

const partner_arr_01 = [partner_01, partner_02, partner_03, partner_04, partner_05];
const partner_arr_02 = [partner_06, partner_07, partner_08, partner_10];

const sectionTitle = [
	{
		text: "OUR",
		color: "defualt",
		break: false,
	},
	{
		text: "PARTNERS",
		color: "main",
		break: true,
	},
];

const drawPartnerImage = (arr) => {
	return (
		<div className="wrap-partners">
			{arr.map((el, index) => {
				return (
					<div className="wrap-img" key={index}>
						<img src={el} alt="partnerImage" />
					</div>
				);
			})}
		</div>
	);
};

const Partners = () => {
	return (
		<section className="Partners">
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="center" withText="true" />
					<p className="section-text center">
						동구밭 팩토리의 고객이 원하는 제품을 만들어내는 뛰어난 품질관리와 기술력에 많은 파트너가 함께 했습니다. 동구밭 팩토리는 고객의 브랜드에 적합한 컨셉과 품질에 가장 적합한 아이디어를 제공하는
						함께 성장하는 준비된 파트너입니다.
					</p>
				</div>
			</div>

			<div className="section-contents">
				<div className="con">
					{drawPartnerImage(partner_arr_01)}
					{drawPartnerImage(partner_arr_02)}
				</div>
			</div>
		</section>
	);
};

export default Partners;
